/* eslint-disable no-undef */
const configs = {
  appTitle: process.env.REACT_APP_NAME || 'Raabta',
  appEnvironment: process.env.REACT_APP_ENVIRONMENT,
  apiBaseUrl: process.env.REACT_APP_API_URL,
  layoutConfigKey: 'LayoutConfig',
  publicURL: process.env.PUBLIC_URL,
}

export default configs
